import { EventEntityHeader } from './EventEntityHeader';

export const ConnectedEventEntityHeader = ({
  title,
}: {
  title: React.ReactNode;
}) => {
  return title ? <EventEntityHeader title={title} /> : null;
};
